import React from 'react'
import { BreachWallContentType } from '../../../helpers/BreachWallTypes'
import {
    StyledPackageImage,
    StyledPackageImageContainer,
} from '../SubscriptionPackageRedesign2026.styled'

type PackageImageProps = {
    breachWallType: BreachWallContentType
    isDigital: boolean
}

// Any package in here must have a corresponding image in the `../assets` folder matching the convention below
const BREACH_PACKAGES_WITH_IMAGES: BreachWallContentType[] = ['50-off-campaign']

export const SubscriptionPackageImage = ({
    breachWallType,
    isDigital,
}: PackageImageProps) => {
    if (!BREACH_PACKAGES_WITH_IMAGES.includes(breachWallType)) {
        return null
    }

    // Ensure the name of the images match the breachWallType when creating to avoid issues.
    const packagePath = isDigital
        ? require(`../assets/${breachWallType}-everyday-digital.png`)
        : require(`../assets/${breachWallType}-everyday-digital-papers.png`)

    return (
        <StyledPackageImageContainer>
            <StyledPackageImage
                src={packagePath}
                alt={
                    isDigital
                        ? 'Everyday Digital subscription offer'
                        : 'Everyday Digital + papers subscription offer'
                }
            />
        </StyledPackageImageContainer>
    )
}
